import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

class ModalMessage extends React.PureComponent {
  render() {
    return (
      <Modal
        isOpen={ get(this.props, 'show') }
        toggle={ get(this.props, 'hide') }
      >
        <ModalHeader toggle={ get(this.props, 'hide') }>
          <Head>
            { get(this.props, 'type') === 200 ? 'Success' : get(this.props, 'type') }
          </Head>
        </ModalHeader>
        <ModalBody>
          <NormalLabel>{ get(this.props, 'message') }</NormalLabel>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default ModalMessage

const NormalLabel = styled(Label)`
  font-family: 'Gotham' !important;
  font-size: 16px ;
`
const Head = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color:#AD2624 ;
`



// WEBPACK FOOTER //
// ./src/components/report/modal/modal-message.js